import styled from "@emotion/styled";
import { Card } from "antd";

export const StyledProfileDetails = styled(Card)`
  width: max-content;
  padding: 16px;
  height: 100%;
  width: 100%;
  background: transparent !important;

  .profile-item {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .profile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    background: #f5f5f5;
    color: #666;
    border-radius: 8px;
    font-size: 18px;
    margin-right: 12px;
  }

  .profile-content {
    flex: 1;
  }

  .profile-label {
    display: block;
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
  }

  .profile-value {
    display: block;
    font-size: 15px;
    color: #333;
  }
`;
